import { render } from "./TransactionList.vue?vue&type=template&id=10d05cbc&scoped=true"
import script from "./TransactionList.vue?vue&type=script&lang=js"
export * from "./TransactionList.vue?vue&type=script&lang=js"

import "./TransactionList.vue?vue&type=style&index=0&id=10d05cbc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d05cbc"]])

export default __exports__